<!-- Showcase for news -->
<ng-container *ngIf="!isLoading; else loadingDynamicTeaserShowcase">
  <div class="top-news">
    <div class="teaser-row">
      <div class="teaser-col-lg-7">
        <ng-container>
          <hdi-teaser
            *ngIf="news.length > 0 && news[0]"
            [type]="TeaserType.LARGE"
            [imageSrc]="news[0].imageSrc"
            [imageAlt]="news[0].imageAlt"
            [imageTitle]="news[0].imageTitle"
            [background]="Colors.NEUTRAL_LIGHTER"
            [badges]="news[0].badges"
            [badgeSize]="Sizes.MEDIUM"
            [date]="news[0].date"
            [headline]="news[0].title"
            [headlineSize]="Headlines.H1"
            [description]="news[0].description"
            [href]="news[0].link?.href ?? ''"
            [hrefType]="news[0].link?.hrefType ?? HrefType.ANGULAR_ROUTE"
            [title]="news[0].link?.title ?? ''"
            [label]="news[0].link?.label ?? ''"
            [linkType]="news[0].link?.linkType ?? LinkType.PRIMARY_ARROW"
            [lazy]="false"
          ></hdi-teaser>
        </ng-container>
      </div>
      <div class="teaser-col-lg-5">
        <div class="teaser-row">
          <div class="teaser-col-12">
            <hdi-teaser
              *ngIf="news.length > 1 && news[1]"
              [type]="TeaserType.SMALL"
              [imageSrc]="news[1].imageSrc"
              [imageAlt]="news[1].imageAlt"
              [imageTitle]="news[1].imageTitle"
              [background]="Colors.NEUTRAL_LIGHTER"
              [badges]="news[1].badges"
              [badgeSize]="Sizes.MEDIUM"
              [date]="news[1].date"
              [headline]="news[1].title"
              [headlineSize]="Headlines.H5"
              [href]="news[1].link?.href ?? ''"
              [hrefType]="news[1].link?.hrefType ?? HrefType.ANGULAR_ROUTE"
              [title]="news[1].link?.title ?? ''"
              [label]="news[1].link?.label ?? ''"
              [linkType]="news[1].link?.linkType ?? LinkType.PRIMARY_ARROW"
              [lazy]="false"
            ></hdi-teaser>
          </div>
          <div class="teaser-col-12">
            <hdi-teaser
              *ngIf="news.length > 2 && news[2]"
              [type]="TeaserType.SMALL"
              [imageSrc]="news[2].imageSrc"
              [imageAlt]="news[2].imageAlt"
              [imageTitle]="news[2].imageTitle"
              [background]="Colors.NEUTRAL_LIGHTER"
              [badges]="news[2].badges"
              [badgeSize]="Sizes.MEDIUM"
              [date]="news[2].date"
              [headline]="news[2].title"
              [headlineSize]="Headlines.H5"
              [href]="news[2].link?.href ?? ''"
              [hrefType]="news[2].link?.hrefType ?? HrefType.ANGULAR_ROUTE"
              [title]="news[2].link?.title ?? ''"
              [label]="news[2].link?.label ?? ''"
              [linkType]="news[2].link?.linkType ?? LinkType.PRIMARY_ARROW"
              [lazy]="false"
            ></hdi-teaser>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="old-news">
    <hdi-teaser-container
      *ngIf="showOldNewsContainer"
      [showMoreLess]="news.length > 6"
      [initialVisibleTeasers]="3"
      [columns]="0"
      #teasersOverview
    >
      <hdi-teaser
        *ngFor="let news of news | slice: 3"
        #teaser
        [type]="TeaserType.SMALL"
        [id]="news.identifier"
        [imageSrc]="news.imageSrc"
        [imageAlt]="news.imageAlt"
        [imageTitle]="news.imageTitle"
        [badges]="news.badges"
        [badgeSize]="Sizes.MEDIUM"
        [date]="news.date"
        [headline]="news.title"
        [headlineSize]="Headlines.H5"
        [description]="news.description"
        [imageBorder]="true"
        [href]="news.link?.href ?? ''"
        [hrefType]="news.link?.hrefType ?? HrefType.ANGULAR_ROUTE"
        [title]="news.link?.title ?? ''"
        [label]="news.link?.label ?? ''"
        [linkType]="news.link?.linkType ?? LinkType.PRIMARY_ARROW"
      ></hdi-teaser>
    </hdi-teaser-container>
  </div>
</ng-container>

<!-- Loading Placeholder -->
<ng-template #loadingDynamicTeaserShowcase>
  <div class="top-news">
    <div class="teaser-row">
      <div class="teaser-col-lg-7">
        <div class="teaser-big-loader">
          <div class="teaser-big-loader__image">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
                'background-color': '#dfe1e6',
              }"
            ></ngx-skeleton-loader>
          </div>
          <div class="teaser-big-loader__content">
            <ngx-skeleton-loader
              [theme]="{
                width: '100%',
                height: '100%',
                'margin-bottom': '0',
                'background-color': '#f9f9fa',
              }"
            ></ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="teaser-col-lg-5">
        <div class="teaser-row">
          <div class="teaser-col-12">
            <div class="teaser-medium-loader">
              <div class="teaser-medium-loader__image">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '100%',
                    height: '100%',
                    'margin-bottom': '0',
                    'background-color': '#dfe1e6',
                  }"
                ></ngx-skeleton-loader>
              </div>
              <div class="teaser-medium-loader__content">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '100%',
                    height: '100%',
                    'margin-bottom': '0',
                    'background-color': '#f9f9fa',
                  }"
                ></ngx-skeleton-loader>
              </div>
            </div>
          </div>
          <div class="teaser-col-12">
            <div class="teaser-medium-loader">
              <div class="teaser-medium-loader__image">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '100%',
                    height: '100%',
                    'margin-bottom': '0',
                    'background-color': '#dfe1e6',
                  }"
                ></ngx-skeleton-loader>
              </div>
              <div class="teaser-medium-loader__content">
                <ngx-skeleton-loader
                  [theme]="{
                    width: '100%',
                    height: '100%',
                    'margin-bottom': '0',
                    'background-color': '#f9f9fa',
                  }"
                ></ngx-skeleton-loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="old-news flex-3-column">
    <div class="teaser-small-loader" *ngFor="let teaser of [].constructor(3)">
      <div class="teaser-small-loader__image">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            'background-color': '#dfe1e6',
          }"
        ></ngx-skeleton-loader>
      </div>
      <div class="teaser-small-loader__content">
        <ngx-skeleton-loader
          [theme]="{
            width: '100%',
            height: '100%',
            'margin-bottom': '0',
            'background-color': '#f9f9fa',
          }"
        ></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</ng-template>
